module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-Semibold-1dd707ef7a0af7d5601165a9021c2190.woff";